export const ButtonStyle = {
    padding: "10px 25px 10px 25px",
    borderRadius: '25px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    height: '50px',
    alignItems: 'center'
};
